import { createFileRoute } from "@tanstack/react-router";
import { SUBSCRIPTION_AGREEMENT } from "@alm/domain";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/legal/subscription-agreement")({
  component: SubscriptionAgreement,
  head: () => ({
    meta: [
      { title: SUBSCRIPTION_AGREEMENT.title },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});

/** A placeholder until the real MSA is signed off; it replaces this page with a new version. */
function SubscriptionAgreement() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-2xl flex-col gap-6 px-4 py-12">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-balance">{SUBSCRIPTION_AGREEMENT.title}</h1>
        <p className="text-muted-foreground text-sm">Version {SUBSCRIPTION_AGREEMENT.version}</p>
      </header>
      <Card>
        <CardContent className="space-y-3 text-sm leading-relaxed">
          <p className="font-medium">The final agreement is being prepared.</p>
          <p className="text-muted-foreground">
            It covers the subscription, fees and billing, data protection and security, and the
            Business Associate Agreement under HIPAA. The full text will be published on this page.
          </p>
          <p className="text-muted-foreground">
            Questions in the meantime: write to info@ppl-ai.com.
          </p>
        </CardContent>
      </Card>
    </main>
  );
}
